/* ==========================================================================
   Loja do Gamão — theme.js
   Sem dependências externas. Tudo em vanilla JS.
   ========================================================================== */
(function () {
  'use strict';

  var moneyRaw = function (cents) {
    var format = (window.LG && window.LG.moneyFormat) || 'R$ {{amount}}';
    var value = (cents / 100).toFixed(2);
    var parts = value.split('.');
    var intPart = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    var withComma = intPart + ',' + parts[1];
    var withoutCents = intPart;

    return format
      .replace(/\{\{\s*amount\s*\}\}/g, withComma)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, withoutCents)
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, withComma)
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g, withoutCents);
  };

  /* Esconde os centavos quando são zero. */
  var money = function (cents) {
    var out = moneyRaw(cents);
    if (cents % 100 === 0) {
      out = out.replace(/[.,]00\b/, '');
    }
    return out;
  };

  /* ----------------------------------------------------------------------
     1. Reveal no scroll
     ---------------------------------------------------------------------- */
  function initReveal(root) {
    var scope = root || document;
    var els = Array.prototype.slice.call(
      scope.querySelectorAll('[data-reveal]:not(.is-visible)')
    );

    if (!els.length) return;

    var show = function (el) {
      el.classList.add('is-visible');
    };

    if (!('IntersectionObserver' in window)) {
      els.forEach(show);
      return;
    }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;

        var delay = parseInt(
          entry.target.getAttribute('data-delay') || '0',
          10
        );

        setTimeout(function () {
          show(entry.target);
        }, delay);

        io.unobserve(entry.target);
      });
    }, {
      threshold: 0.05,
      rootMargin: '0px 0px -40px 0px'
    });

    els.forEach(function (el) {
      io.observe(el);
    });

    setTimeout(function () {
      els.forEach(show);
    }, 2500);
  }

  /* ----------------------------------------------------------------------
     2. Menu mobile
     ---------------------------------------------------------------------- */
  function initMobileMenu(root) {
    var scope = root || document;

    scope.querySelectorAll('[data-menu-toggle]').forEach(function (btn) {
      if (btn.dataset.bound === '1') return;
      btn.dataset.bound = '1';

      btn.addEventListener('click', function () {
        var target = document.getElementById(
          btn.getAttribute('aria-controls')
        );

        if (!target) return;

        var open = target.classList.toggle('is-open');
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    });
  }

  /* ----------------------------------------------------------------------
     3. Acordeões de filtros
     ---------------------------------------------------------------------- */
  function initFacets(root) {
    var scope = root || document;

    scope.querySelectorAll('[data-facets-toggle]').forEach(function (btn) {
      if (btn.dataset.bound === '1') return;
      btn.dataset.bound = '1';

      btn.addEventListener('click', function () {
        var panel = document.getElementById(
          btn.getAttribute('aria-controls')
        );

        if (!panel) return;

        var open = panel.classList.toggle('is-open');
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    });

    scope.querySelectorAll('[data-auto-submit]').forEach(function (el) {
      if (el.dataset.bound === '1') return;
      el.dataset.bound = '1';

      el.addEventListener('change', function () {
        var form = el.closest('form');
        if (form) form.submit();
      });
    });
  }

  /* ----------------------------------------------------------------------
     4. Galeria do produto
     ---------------------------------------------------------------------- */
  function initGallery(root) {
    var scope = root || document;

    scope.querySelectorAll('[data-gallery]').forEach(function (gallery) {
      if (gallery.dataset.bound === '1') return;
      gallery.dataset.bound = '1';

      var main = gallery.querySelector('[data-gallery-main]');

      gallery.querySelectorAll('[data-gallery-thumb]').forEach(function (thumb) {
        thumb.addEventListener('click', function () {
          if (!main) return;

          var src = thumb.getAttribute('data-src');
          var srcset = thumb.getAttribute('data-srcset');
          var alt = thumb.getAttribute('data-alt') || '';

          if (src) main.setAttribute('src', src);
          if (srcset) main.setAttribute('srcset', srcset);

          main.setAttribute('alt', alt);

          gallery.querySelectorAll('[data-gallery-thumb]').forEach(function (t) {
            t.setAttribute('aria-current', t === thumb ? 'true' : 'false');
          });
        });
      });
    });
  }

  /* ----------------------------------------------------------------------
     5. Quantidade
     ---------------------------------------------------------------------- */
  function initQty(root) {
    var scope = root || document;

    scope.querySelectorAll('[data-qty]').forEach(function (wrap) {
      if (wrap.dataset.bound === '1') return;
      wrap.dataset.bound = '1';

      var input = wrap.querySelector('input');

      wrap.querySelectorAll('[data-qty-change]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          if (!input) return;

          var step = parseInt(btn.getAttribute('data-qty-change'), 10);
          var min = parseInt(input.getAttribute('min') || '1', 10);
          var next = (parseInt(input.value, 10) || min) + step;

          input.value = next < min ? min : next;
          input.dispatchEvent(new Event('change', { bubbles: true }));
        });
      });
    });
  }

  /* ----------------------------------------------------------------------
     6. Seleção de variantes
     ---------------------------------------------------------------------- */
  function initVariants(root) {
    var scope = root || document;

    scope.querySelectorAll('[data-variant-picker]').forEach(function (picker) {
      if (picker.dataset.bound === '1') return;
      picker.dataset.bound = '1';

      var dataEl = picker.querySelector('[data-variant-json]');
      if (!dataEl) return;

      var variants;

      try {
        variants = JSON.parse(dataEl.textContent);
      } catch (e) {
        return;
      }

      var form = document.getElementById(picker.getAttribute('data-form'));
      var idInput = form ? form.querySelector('[name="id"]') : null;
      var section = picker.closest('[data-product-root]') || document;

      var priceEl = section.querySelector('[data-price]');
      var compareEl = section.querySelector('[data-price-compare]');
      var pixEl = section.querySelector('[data-price-pix]');
      var stickyEl = section.querySelector('[data-sticky-price]');
      var addButtons = section.querySelectorAll('[data-add-button]');
      var skuEl = section.querySelector('[data-variant-sku]');
      var labelEls = section.querySelectorAll('[data-option-label]');
      var mainImage = section.querySelector('[data-gallery-main]');

      var pixRate = parseFloat(
        picker.getAttribute('data-pix-rate') || '0'
      );

      function currentOptions() {
        var values = [];

        picker.querySelectorAll('[data-option-index]').forEach(function (group) {
          var checked = group.querySelector('input:checked');

          values[parseInt(group.getAttribute('data-option-index'), 10)] =
            checked ? checked.value : null;
        });

        return values;
      }

      function findVariant(values) {
        for (var i = 0; i < variants.length; i++) {
          var v = variants[i];
          var match = true;

          for (var j = 0; j < values.length; j++) {
            if (values[j] === null) continue;

            if (v.options[j] !== values[j]) {
              match = false;
              break;
            }
          }

          if (match) return v;
        }

        return null;
      }

      function update() {
        var values = currentOptions();
        var variant = findVariant(values);

        labelEls.forEach(function (el) {
          var idx = parseInt(el.getAttribute('data-option-label'), 10);
          var base = el.getAttribute('data-option-name') || '';

          if (values[idx]) {
            el.textContent = base + ' · ' + values[idx];
          }
        });

        if (!variant) {
          addButtons.forEach(function (b) {
            b.setAttribute('disabled', 'disabled');
            b.textContent = b.getAttribute('data-unavailable-text') || 'Indisponível';
          });
          return;
        }

        if (idInput) idInput.value = variant.id;

        try {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', variant.id);
          window.history.replaceState({}, '', url.toString());
        } catch (e) {
          /* noop */
        }

        if (priceEl) priceEl.textContent = money(variant.price);
        if (stickyEl) stickyEl.textContent = money(variant.price);

        if (compareEl) {
          if (variant.compare_at_price && variant.compare_at_price > variant.price) {
            compareEl.textContent = money(variant.compare_at_price);
            compareEl.hidden = false;
          } else {
            compareEl.hidden = true;
          }
        }

        if (pixEl && pixRate > 0) {
          var pixValue = money(
            Math.round(variant.price * (1 - pixRate / 100))
          );

          pixEl.textContent = [
            pixEl.getAttribute('data-prefix') || '',
            pixValue,
            pixEl.getAttribute('data-suffix') || ''
          ].join(' ').replace(/\s+/g, ' ').trim();
        }

        if (skuEl) skuEl.textContent = variant.sku || '';

        if (mainImage && variant.featured_image && variant.featured_image.src) {
          mainImage.setAttribute('src', variant.featured_image.src);
          mainImage.removeAttribute('srcset');
        }

        addButtons.forEach(function (b) {
          if (variant.available) {
            b.removeAttribute('disabled');
            b.textContent = b.getAttribute('data-default-text') || 'Adicionar à sacola';
          } else {
            b.setAttribute('disabled', 'disabled');
            b.textContent = b.getAttribute('data-soldout-text') || 'Esgotado';
          }
        });
      }

      picker.addEventListener('change', update);
      update();
    });
  }

  /* ----------------------------------------------------------------------
     7. Confirmação de adição e contador da sacola
     ---------------------------------------------------------------------- */
  var cartNotice;
  var cartNoticeMessage;
  var cartNoticeReturnFocus;

  function initCartFeedback() {
    if (!document.getElementById('lg-cart-feedback-style')) {
      var style = document.createElement('style');
      style.id = 'lg-cart-feedback-style';

      style.textContent =
        '.lg-cart-notice{position:fixed;z-index:1000;top:calc(16px + env(safe-area-inset-top,0px));left:50%;transform:translateX(-50%);width:calc(100% - 32px);max-width:400px;padding:20px 56px 20px 20px;border:1px solid rgba(22,19,14,.12);border-radius:16px;background:var(--cream,#fcf8f2);color:var(--ink,#16130e);box-shadow:0 12px 40px rgba(0,0,0,.18);font-family:var(--font-body,sans-serif);box-sizing:border-box;}' +
        '.lg-cart-notice[hidden]{display:none;}' +
        '.lg-cart-notice__message{margin:0;font-size:15px;font-weight:600;line-height:1.45;overflow-wrap:anywhere;}' +
        '.lg-cart-notice__link{display:inline-flex;align-items:center;min-height:44px;margin-top:6px;color:inherit;text-decoration:underline;text-underline-offset:4px;font-size:14px;font-weight:600;}' +
        '.lg-cart-notice__close{position:absolute;right:6px;top:6px;display:flex;align-items:center;justify-content:center;width:44px;height:44px;padding:0;border:0;background:transparent;color:inherit;font-size:26px;cursor:pointer;}' +
        '.header__mobile .lg-cart-link{position:relative;}' +
        '.header__mobile .lg-cart-count{position:absolute;top:0;right:0;display:flex;align-items:center;justify-content:center;min-width:17px;height:17px;padding:0 4px;border-radius:999px;background:var(--red,#a93226);color:#fff;font-size:10px;font-weight:700;line-height:1;pointer-events:none;}' +
        '.header__mobile .lg-cart-count[hidden]{display:none;}';

      document.head.appendChild(style);
    }

    if (!cartNotice) {
      cartNotice = document.createElement('div');
      cartNotice.className = 'lg-cart-notice';
      cartNotice.hidden = true;

      cartNotice.innerHTML =
        '<p class="lg-cart-notice__message" role="status" aria-live="polite" aria-atomic="true"></p>' +
        '<a class="lg-cart-notice__link">Ver sacola →</a>' +
        '<button type="button" class="lg-cart-notice__close" aria-label="Fechar aviso">×</button>';

      cartNotice.querySelector('a').href =
        (window.LG && window.LG.routes && window.LG.routes.cart) || '/cart';

      cartNoticeMessage = cartNotice.querySelector('p');

      function closeNotice() {
        var restoreFocus = cartNotice.contains(document.activeElement);
        cartNotice.hidden = true;

        if (
          restoreFocus &&
          cartNoticeReturnFocus &&
          cartNoticeReturnFocus.isConnected
        ) {
          cartNoticeReturnFocus.focus();
        }
      }

      cartNotice.querySelector('button').addEventListener('click', closeNotice);

      cartNotice.addEventListener('keydown', function (event) {
        if (event.key === 'Escape') closeNotice();
      });

      document.body.appendChild(cartNotice);
    }

    var initialCount = document.querySelector('[data-cart-count]');
    var count = initialCount ? parseInt(initialCount.textContent, 10) || 0 : 0;

    var cartPath = new URL(
      (window.LG && window.LG.routes && window.LG.routes.cart) || '/cart',
      window.location.origin
    ).pathname;

    document.querySelectorAll('.header__mobile a.header__icon-btn').forEach(function (link) {
      if (
        new URL(link.href).pathname !== cartPath ||
        link.querySelector('[data-cart-count]')
      ) {
        return;
      }

      link.classList.add('lg-cart-link');

      var badge = document.createElement('span');
      badge.className = 'lg-cart-count';
      badge.setAttribute('data-cart-count', '');
      badge.setAttribute('aria-hidden', 'true');
      badge.textContent = count;
      badge.hidden = count === 0;

      link.appendChild(badge);
      link.setAttribute('aria-label', 'Abrir sacola, ' + count + ' itens');
    });
  }

  function showCartNotice(message, trigger) {
    initCartFeedback();

    cartNoticeReturnFocus = trigger || document.activeElement;
    cartNoticeMessage.textContent = '';
    cartNotice.hidden = false;

    requestAnimationFrame(function () {
      cartNoticeMessage.textContent = message;
    });

    if (
      cartNotice.animate &&
      !window.matchMedia('(prefers-reduced-motion: reduce)').matches
    ) {
      cartNotice.animate([
        { opacity: 0, transform: 'translate(-50%, -10px)' },
        { opacity: 1, transform: 'translate(-50%, 0)' }
      ], {
        duration: 240,
        easing: 'ease-out'
      });
    }
  }

  function refreshCartCount() {
    return fetch(
      window.Shopify && window.Shopify.routes
        ? window.Shopify.routes.root + 'cart.js'
        : '/cart.js',
      {
        headers: { 'Accept': 'application/json' }
      }
    )
      .then(function (r) {
        return r.json();
      })
      .then(function (cart) {
        document.querySelectorAll('[data-cart-count]').forEach(function (el) {
          el.textContent = cart.item_count;

          if (el.classList.contains('lg-cart-count')) {
            el.hidden = cart.item_count === 0;
            el.parentElement.setAttribute(
              'aria-label',
              'Abrir sacola, ' + cart.item_count + ' itens'
            );
          }
        });
      })
      .catch(function () {
        /* noop */
      });
  }

  function initAjaxAdd(root) {
    var scope = root || document;

    scope.querySelectorAll('form[data-ajax-add]').forEach(function (form) {
      if (form.dataset.bound === '1') return;

      if (
        !document.getElementById('LGCartDrawer') && (
          form.getAttribute('data-ajax-add') === 'off' ||
          form.getAttribute('data-ajax-add') === 'false'
        )
      ) {
        return;
      }

      form.dataset.bound = '1';

      form.addEventListener('submit', function (event) {
        if (event.submitter && event.submitter.name === 'checkout') return;
        event.preventDefault();
        if (window.LGCartDrawer && window.LGCartDrawer.isBusy()) return;

        if (form.dataset.adding === 'true') return;
        form.dataset.adding = 'true';

        var payload = new FormData(form);
        var trigger = event.submitter || document.activeElement;

        var buttons = Array.prototype.filter.call(
          document.querySelectorAll('[data-add-button]'),
          function (button) {
            return button.form === form;
          }
        ).map(function (button) {
          return {
            element: button,
            text: button.textContent,
            disabled: button.disabled
          };
        });

        var msg = form.querySelector('[data-add-error]');

        if (msg) {
          msg.hidden = true;
          msg.textContent = '';
        }

        if (cartNotice) cartNotice.hidden = true;

        buttons.forEach(function (item) {
          item.element.disabled = true;
          item.element.textContent = 'Adicionando…';
        });

        function restoreButtons() {
          buttons.forEach(function (item) {
            if (
              item.element.textContent === 'Adicionando…' ||
              item.element.textContent === 'Adicionado ✓'
            ) {
              item.element.disabled = item.disabled;
              item.element.textContent = item.text;
            }
          });

          delete form.dataset.adding;
        }

        fetch(
          (window.Shopify && window.Shopify.routes
            ? window.Shopify.routes.root
            : '/') + 'cart/add.js',
          {
            method: 'POST',
            headers: { 'Accept': 'application/json' },
            body: payload
          }
        )
          .then(function (r) {
            return r.json().then(function (data) {
              if (!r.ok || data.status) {
                throw new Error(
                  data.description ||
                  data.message ||
                  'Não foi possível adicionar o produto.'
                );
              }

              return data;
            });
          })
          .then(function (data) {
            buttons.forEach(function (item) {
              if (item.element.textContent === 'Adicionando…') {
                item.element.textContent = 'Adicionado ✓';
              }
            });

            if (window.LGCartDrawer) {
              window.LGCartDrawer.open(trigger);
            } else {
              showCartNotice('✓ Produto adicionado à sacola!', trigger);
            }
            refreshCartCount();
            setTimeout(restoreButtons, 1600);
          })
          .catch(function (err) {
            restoreButtons();

            var message = err instanceof TypeError || err instanceof SyntaxError
              ? 'Não foi possível confirmar a adição. Confira a sacola antes de tentar novamente.'
              : err.message;

            if (msg) {
              msg.textContent = message;
              msg.hidden = false;
            }

            showCartNotice(message, trigger);
          });
      });
    });
  }

  /* ----------------------------------------------------------------------
     8. Carrinho — quantidade e remoção
     ---------------------------------------------------------------------- */
  function initCart(root) {
    var scope = root || document;

    scope.querySelectorAll('[data-cart-form]').forEach(function (form) {
      if (form.dataset.bound === '1') return;
      form.dataset.bound = '1';

      form.querySelectorAll('[data-cart-qty]').forEach(function (input) {
        input.addEventListener('change', function () {
          form.submit();
        });
      });
    });
  }

  /* ----------------------------------------------------------------------
     8b. Cupom de desconto
     ---------------------------------------------------------------------- */
  function initCoupon(root) {
    var scope = root || document;

    scope.querySelectorAll('[data-coupon]').forEach(function (box) {
      if (box.closest('#LGCartDrawer')) return;
      if (box.dataset.bound === '1') return;
      box.dataset.bound = '1';

      var input = box.querySelector('[data-coupon-input]');
      var button = box.querySelector('[data-coupon-apply]');

      var go = function () {
        var code = (input && input.value || '').trim();

        if (!code) {
          if (input) input.focus();
          return;
        }

        var root = window.Shopify && window.Shopify.routes
          ? window.Shopify.routes.root
          : '/';

        var redirect = box.getAttribute('data-redirect') || (root + 'cart');

        window.location.href =
          root + 'discount/' + encodeURIComponent(code) +
          '?redirect=' + encodeURIComponent(redirect);
      };

      if (button) button.addEventListener('click', go);

      if (input) {
        input.addEventListener('keydown', function (e) {
          if (e.key === 'Enter') {
            e.preventDefault();
            go();
          }
        });
      }
    });
  }

  /* ----------------------------------------------------------------------
     9. Vídeo com clique para tocar
     ---------------------------------------------------------------------- */
  function initVideo(root) {
    var scope = root || document;

    scope.querySelectorAll('[data-video-trigger]').forEach(function (btn) {
      if (btn.dataset.bound === '1') return;
      btn.dataset.bound = '1';

      btn.addEventListener('click', function () {
        var frame = btn.closest('.video-frame');
        var src = btn.getAttribute('data-video-src');

        if (!frame || !src) return;

        var iframe = document.createElement('iframe');

        iframe.setAttribute('src', src);
        iframe.setAttribute('allow', 'autoplay; encrypted-media; picture-in-picture');
        iframe.setAttribute('allowfullscreen', 'true');
        iframe.setAttribute('title', btn.getAttribute('data-video-title') || 'Vídeo');

        frame.innerHTML = '';
        frame.appendChild(iframe);
      });
    });
  }

  /* ----------------------------------------------------------------------
     Boot
     ---------------------------------------------------------------------- */
  function initAll(root) {
    initCartFeedback();
    initReveal(root);
    initMobileMenu(root);
    initFacets(root);
    initGallery(root);
    initQty(root);
    initVariants(root);
    initAjaxAdd(root);
    initCart(root);
    initCoupon(root);
    initVideo(root);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll(document);
    });
  } else {
    initAll(document);
  }

  /* Editor de temas do Shopify */
  document.addEventListener('shopify:section:load', function (e) {
    initAll(e.target);
  });

  document.addEventListener('shopify:section:select', function (e) {
    initReveal(e.target);
  });

  document.addEventListener('shopify:block:select', function (e) {
    initReveal(e.target);
  });

  window.LGTheme = {
    init: initAll,
    money: money,
    moneyRaw: moneyRaw,
    refreshCartCount: refreshCartCount
  };
})();